import React from 'react';
import { connect } from 'react-redux';
import { TitleBar, Card, Layout, StatusMessage, SelectAndSearch } from '../components/library-components';
import '../../stylesheets/pages/subscriptions.scss';

export class SearchSubscriber extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showNotification: { isNotificationOpen: false, status: '', statusMessage: '' }
    };
  }

  render () {
    return (
      <Layout>
        <TitleBar title="Subscribers" breadcrumbTitle='Home' breadcrumbPath='/' />

        <Card title='Search Subscriber'>
          <SelectAndSearch subscriptionGroupId={'all'} />
        </Card>

        {this.state.showNotification.isNotificationOpen &&
          <StatusMessage statusMessage={this.state.showNotification.statusMessage}
            status={this.state.showNotification.status}
            onCancel={() => this.setState({ showNotification: { isNotificationOpen: false, status: '', statusMessage: '' } })} />}
      </Layout>
    );
  }
}

function mapStateToProps (state) {
  return {};
}

function mapDispatchToProps (dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchSubscriber);
